module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-meta"
  }, [_c('div', {
    staticClass: "jump-rj-warp"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "jump-rj-btn relative",
    class: [_vm.addVertical]
  }, [_vm._v("\n\t\t\t进入睿江云小程序\n\t\t\t"), _c('a', {
    staticClass: "jump-warp",
    attrs: {
      "href": "/user/resources.html"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "footer-suspension-main",
    class: {
      'hide': !_vm.suspensionShow
    }
  }, [_c('div', {
    staticClass: "footer-suspension-warp box"
  }, [_c('div', {
    staticClass: "box footer-suspension-left"
  }, [_c('i', {
    staticClass: "iconfont icon-error",
    on: {
      "click": function($event) {
        _vm.closeSuspension()
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "btn footer-suspension-btn relative",
    class: [_vm.addVertical]
  }, [_vm._v("\n\t\t\t\t打开小程序\n\t\t\t\t"), _c('a', {
    staticClass: "jump-warp",
    attrs: {
      "href": "/user/resources.html"
    }
  })])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "jump-rj-title box"
  }, [_c('li', {
    staticClass: "jump-rj-title-item jump-rj-title-left"
  }, [_c('span', {
    staticClass: "border-ri"
  }, [_vm._v("轻松掌管帐号")])]), _vm._v(" "), _c('li', {
    staticClass: "jump-rj-title-item"
  }, [_vm._v("便捷管理资源")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-icp"
  }, [_vm._v("\n\t\t©2019 睿江云版本所有证"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn/"
    }
  }, [_vm._v("粤ICP备09026812号")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44060402000908"
    }
  }, [_vm._v("粤公网安备44060402000908号")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-suspension-phone"
  }, [_c('a', {
    attrs: {
      "href": "tel:4000662212"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../common/images/footer-meta/tel.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "phone-animate"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-suspension-content box"
  }, [_c('img', {
    staticClass: "footer-suspension-img",
    attrs: {
      "src": require("../../common/images/footer-meta/code.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "footer-suspension-title"
  }, [_vm._v("睿江云小程序")]), _vm._v(" "), _c('li', {
    staticClass: "footer-suspension-tips"
  }, [_vm._v("轻松掌控账号，便捷管理资源")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5230d661!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footerMeta/footerMeta.vue
// module id = 23
// module chunks = 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44